(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class SGHeaderStateController {
    constructor(host) {
      this.host = host;
      this.wrapper = host.querySelector('.sg-header-wrapper');
      this.detailsElements = host.querySelectorAll('details');

      if (!this.wrapper) return;

      this.handleToggle = this.syncState.bind(this);
      this.detailsElements.forEach((detailsElement) => {
        detailsElement.addEventListener('toggle', this.handleToggle);
      });

      this.syncState();
    }

    syncState() {
      if (!this.wrapper) return;

      const hasOpenDetails = Array.from(this.detailsElements).some((detailsElement) => detailsElement.open);
      this.wrapper.classList.toggle('sg-header-wrapper--modal-open', hasOpenDetails);
    }
  }

  const initializeSGHeaderStateControllers = (root = document) => {
    root.querySelectorAll('.sg-header-host').forEach((host) => {
      if (host.sgHeaderStateController) return;
      host.sgHeaderStateController = new SGHeaderStateController(host);
    });
  };

  class SGStickyHeader extends HTMLElement {
    connectedCallback() {
      this.wrapper = this.querySelector('.sg-header-wrapper');
      this.sectionHeader = this.closest('.section-header');
      this.headerIsAlwaysSticky = this.dataset.stickyType === 'always';
      this.currentScrollTop = 0;
      this.headerBounds = {};

      this.setHeaderHeight();
      window.addEventListener('resize', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.sectionHeader.classList.add('shopify-section-header-sticky');
      }

      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.offsetHeight}px`);
    }

    createObserver() {
      const observer = new IntersectionObserver((entries, currentObserver) => {
        this.headerBounds = entries[0].intersectionRect;
        currentObserver.disconnect();
      });

      observer.observe(this.sectionHeader);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.headerIsAlwaysSticky && scrollTop > 8) {
        this.sectionHeader.classList.add('shopify-section-header-sticky');
      }

      if (this.headerIsAlwaysSticky) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.hide();
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.reveal();
      } else if (scrollTop <= this.headerBounds.top) {
        this.reset();
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.sectionHeader.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      this.sectionHeader.classList.add('shopify-section-header-sticky');
      this.sectionHeader.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.sectionHeader.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', SGStickyHeader);
  }

  initializeSGHeaderStateControllers();
  document.addEventListener('shopify:section:load', (event) => initializeSGHeaderStateControllers(event.target));

  } catch(e) { console.error(e); }
})();
})();
